import { createBrowserRouter } from "react-router-dom";
import Main from "Layouts/Main";
import AuthLayout from "Layouts/AuthLayout"; // Layout WITHOUT Navbar/Footer
import LocationLayout from "Layouts/LocationLayout";
import Location from "Pages/Location/Location";
import AdminRoute from "Components/Admin/AdminRoute";
import AdminDashboard from "Pages/Admin/AdminDashboard";
import TournamentFormPage from "Pages/Admin/TournamentFormPage";
import TournamentProgressPage from "Pages/Tournament/TournamentProgressPage";
import LocationFormPage from "Pages/Location/LocationFormPage";
import RankingAdminPage from "Pages/Location/RankingAdminPage";
import MyMatches from "Components/Tournament/MyMatches";
import Home from "Pages/Home/Home/Home";
import Error from "Pages/Shared/Error/Error";
import Login from "Pages/Auth/Login";
import Signup from "Pages/Auth/Signup";
import MapPage from "Pages/Map/MapPage";
import MapEmbedPage from "Pages/Map/MapEmbedPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    errorElement: <Error />,
    children: [{ path: "/", element: <Home /> }],
  },
  {
    path: "/",
    element: <AuthLayout />, // Layout without Navbar/Footer
    children: [
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <Signup /> },
    ],
  },
  {
    path: "/",
    element: <LocationLayout />,
    children: [
      { path: "/carte", element: <MapPage /> },
      { path: "/locations/:locationId", element: <Location /> },
      {
        path: "/locations/:locationId/edit",
        element: <LocationFormPage />,
      },
      {
        path: "/locations/:locationId/rankings",
        element: <RankingAdminPage />,
      },
      {
        path: "/locations/tournaments/new/:locationId",
        element: <TournamentFormPage />,
      },
      {
        path: "/locations/tournaments/edit/:tournamentId",
        element: <TournamentFormPage />,
      },
      {
        path: "/locations/tournaments/:tournamentId/progress",
        element: <TournamentProgressPage />,
      },
      {
        path: "/locations/tournaments/:tournamentId/my-matches",
        element: <MyMatches />,
      },
    ],
  },
  {
    // Chrome-less map for iframes on other sites (see public/embed.js)
    path: "/carte/embed",
    element: <MapEmbedPage />,
  },
  {
    path: "/admin",
    element: <AdminRoute />, // Protect admin pages
    children: [
      { path: "/admin/dashboard", element: <AdminDashboard /> },
    ],
  },
]);

export default router;


